export default function isObject(object: unknown): boolean {
  if (object === null) {
    return false;
  }

  return typeof object === 'object';
}
